import React from "react";
import { TimerBox } from "../styles";
import { StructuresResponse } from "../../../tournament/hook/useEditTournament";
import BlindInfoContainer from "./blindDisplay";

interface TimerDisplayProps {
  type: "LEVEL" | "BREAK" | string;
  level?: number;
  remainingTime: string;
  currentLevel: StructuresResponse | null;
  nextLevel: StructuresResponse | null;
  hasStarted: boolean;
  isGameStarted: boolean;
  elapsedTimeMs: number;
}

const TimerDisplay = ({
  type,
  level,
  remainingTime,
  hasStarted,
  currentLevel,
  nextLevel,
  isGameStarted,
  elapsedTimeMs,
}: TimerDisplayProps) => {
  return (
    <TimerBox>
      <img alt="로고" src="/image-web/timer/timer1-logo.svg" />
      <div className={`now-level ${type === "BREAK" ? "break" : ""}`}>
        {hasStarted && elapsedTimeMs > 0
          ? type === "LEVEL" && level
            ? `현재 ${level}LV`
            : "BREAK"
          : "시작 준비중"}
      </div>

      <div
        className={`time ${
          type === "LEVEL" && elapsedTimeMs > 0 ? "level" : ""
        }`}
      >
        {remainingTime}
      </div>
      <BlindInfoContainer
        nextLevel={nextLevel}
        currentLevel={currentLevel}
        isGameStarted={isGameStarted}
      />
    </TimerBox>
  );
};

export default TimerDisplay;
